import { IApiHandlerParams } from "@/api/interface";

export const HOST_URL: string = process.env.VUE_APP_HOST_URL;

export const API_URL: string = HOST_URL + process.env.VUE_APP_API_URL;

export const API_DEF_CONFIG: Required<IApiHandlerParams> = {
	dontShowErrorMessage: false,
	disableLoader: false,
	dontUseApiUrl: false,
	skipChecking: false,
	returnData: true,
	dontAuth: false,
	useRefreshToken: false,
	showModalOnError: false,
	ignoreErrorHandler: false,
	skipSessionExpired: false
};